export const geoConstants = {
    VILLES_FETCH_REQUEST: 'GEO_VILLES_FETCH_REQUEST',
    VILLES_FETCH_SUCCESS: 'GEO_VILLES_FETCH_SUCCESS',
    VILLES_FETCH_FAILURE: 'GEO_VILLES_FETCH_FAILURE',
    CLEAR: 'GEO_CLEAR_REQUEST',
};
